<template lang="pug">
  .input-form(:class="{'--password': type === 'password', '--error': error }")
    //.input-form__title(v-if="title")
      | {{ title }}

    label.input-form__label
      textarea(
        v-if="type === 'textarea'"
        :placeholder="placeholder"
        :disabled="localDisabled"
        @input="onInput"
        @blur="onBlur"
      )
        | {{ value }}

      input(
        v-else
        :type="currentType"
        :value="value"
        :placeholder="placeholder"
        :disabled="localDisabled"
        @input="onInput"
        @blur="onBlur"
        @keypress="onKeypress"
      )

      .input-form__icon(v-if="type === 'password'" @click="togglePasswordVisibility")
        InlineSvg(:src="require(`@/assets/img/icons/${passwordIcon}.svg`)")
      .input-form__icon(v-if="icon" :class="{'input-form__icon--right': iconRight}")
        InlineSvg(:src="require(`@/assets/img/icons/${icon}.svg`)")
      .input-form__error(v-if="error")
        | {{ error }}
      button.input-form__edit(v-if="isEditable" @click="edit" title="Редактировать")
        InlineSvg(:src="require('@/assets/img/icons/edit.svg')")
</template>

<script>
export default {
  name: 'InputForm',

  props: {
    title: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    icon: {
      type: String,
      default: '',
    },

    value: {
      type: [String, Number],
      default: '',
    },

    type: {
      type: String,
      default: 'text',
    },

    error: {
      type: String,
      default: '',
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },

    isEditable: {
      type: Boolean,
      default: false,
    },

    iconRight: {
      type: Boolean,
      default: false
    },
  },

  data({ isDisabled }) {
    return {
      isPasswordVisible: false,
      localDisabled: isDisabled,
    }
  },

  computed: {
    currentType() {
      if (this.type === 'password' && this.isPasswordVisible) {
        return 'text'
      }

      return this.type
    },

    passwordIcon() {
      return this.isPasswordVisible ? 'eye-closed' : 'eye'
    },
  },

  created() {
    this.localDisabled = this.isEditable || this.isDisabled
  },

  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible
    },

    onInput({ target: { value } }) {
      this.$emit('input', value)
    },

    onBlur() {
      this.$emit('blur')
    },

    onKeypress(event) {
      this.$emit('keypress', event)
    },

    edit() {
      this.localDisabled = !this.localDisabled
    },
  },
}
</script>

<style lang="scss">
.input-form {
  &__title {
    @include caption-small;

    color: $grey20;
    margin-bottom: 16px;
  }

  &__label {
    position: relative;
    // background: $blue-grey70;
    background: $blue-grey60;
    width: 100%;
    display: block;
    border-radius: 8px;
    transition: background 0.3s $easing;

    .--error > & {
      background: $red60-20;
    }

    input,
    textarea {
      border-radius: 8px;
      padding: 0 36px 0 16px;
      height: 48px;
      width: 100%;
      border: 0;
      outline: none;
      background: transparent;
      color: $white;
      @include text-display100;
      font-weight: 500;

      &::placeholder {
        @include hint;

        color: $white20;
      }

      &:-webkit-autofill {
        background: transparent !important;
      }

      &[disabled] {
        opacity: 0.3;
        cursor: not-allowed;
      }
    }

    /* stylelint-disable-next-line */
    textarea {
      height: auto;
      min-height: 96px;
      padding-top: 16px;
      padding-bottom: 16px;
      line-height: 100%;
    }
  }

  &__icon {
    position: absolute;
    top: 12px;
    left: 12px;
    width: 24px;
    height: 24px;
    display: flex;
    cursor: pointer;

    .--password & {
      left: auto;
      right: 12px;
    }

    &--right {
      left: auto;
      right: 12px;
    }
  }

  &__pass-icon {
    position: absolute;
    top: 12px;
    right: 16px;
    cursor: pointer;
  }

  &__error {
    @include text-display100;

    position: absolute;
    bottom: -22px;
    right: 0;
    font-size: 18px;
    color: $red40;
  }

  &__edit {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 48px;
    height: 48px;
    margin: 0;
    padding: 0;
    border: 0;
    background: 0;
    cursor: pointer;
    transition: opacity 0.3s $easing;

    &:hover {
      opacity: 0.7;
    }

    .--password & {
      right: 36px;
    }
  }
}
</style>
